import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import Counter from '@quintoandar/cozy-core/Counter';
import Box from '@quintoandar/cozy-core/Box';
import Typography from '@quintoandar/cozy-core/Typography';

import { getMessageByIntlKey } from 'components/DynamicForm/getMessageByIntlKey';

import messages from './messages';

export const FlexCounter = ({
  intlKey,
  value = null,
  onChange,
  onValidateItem,
  shouldValidate,
  intl,
}) => {
  const [valid, setValid] = useState(true);

  const hasValue = value !== null;

  useEffect(
    () => {
      if (onValidateItem) {
        onValidateItem(hasValue);
      }
    },
    [hasValue],
  );

  useEffect(
    () => {
      if (shouldValidate && valid !== hasValue) {
        setValid(hasValue);
      }
    },

    [(shouldValidate, valid, hasValue)],
  );

  const counterRange = {
    min: 0,
    max: Infinity,
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      my={2}
    >
      <Box>
        <Typography>
          {intl.formatMessage(
            getMessageByIntlKey({ availableMessages: messages, intlKey }),
          )}
        </Typography>
        {!valid && (
          <Typography kind="critical">
            <FormattedMessage {...messages.invalid} />
          </Typography>
        )}
      </Box>
      <Counter
        range={counterRange}
        buttonSize="small"
        value={value || 0}
        onClick={onChange}
      />
    </Box>
  );
};

FlexCounter.propTypes = {
  intlKey: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  onValidateItem: PropTypes.func,
  shouldValidate: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(FlexCounter);
